import { forwardRef } from "react";

import { cx } from "#ui/style.utils";

type DisclosureTextRef = React.ComponentRef<"div">;

interface DisclosureTextProps extends React.ComponentPropsWithoutRef<"div"> {
  id: string;
}

const DisclosureText = forwardRef<DisclosureTextRef, DisclosureTextProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        {...props}
        className={cx("text-xs text-shade-80", className)}
        ref={ref}
      />
    );
  },
);

DisclosureText.displayName = "DisclosureText";

export { DisclosureText };
